// All display dates/times in Australia/Sydney (AEST/AEDT handled by Intl). Offset-less ISO from the API is UTC.
export const SYD = "Australia/Sydney";

export function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  const s = String(v);
  const utc = /T\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s) ? `${s}Z` : s;
  const d = new Date(utc);
  return Number.isNaN(d.getTime()) ? null : d;
}

const fmt = (v, opts, empty = "") => {
  const d = toDate(v);
  return d ? d.toLocaleString("en-AU", { timeZone: SYD, ...opts }) : empty;
};

export const sydDateTime = (v, empty = "") => fmt(v, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }, empty);
export const sydDate = (v, empty = "") => fmt(v, { day: "numeric", month: "short", year: "numeric" }, empty);
export const sydDayMonth = (v, empty = "") => fmt(v, { day: "numeric", month: "short" }, empty);
export const sydTime = (v, empty = "") => fmt(v, { hour: "2-digit", minute: "2-digit" }, empty);
